// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAddWorkflows_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.4058 11.1077 23.2772.236328 24.6914 1.65054 14.8812 11.4607C16.1152 14.3732 15.5463 17.8667 13.1715 20.2415 10.7968 22.6162 7.30329 23.1851 4.39076 21.9512L3.27203 23.0699 8.92888 28.7267 30.3482 7.3074 31.7624 8.72161 8.92888 31.5552.443604 23.0699 4.0378 19.4757C6.381 21.1456 9.65509 20.9295 11.7573 18.8272 13.8595 16.725 14.0757 13.4509 12.4058 11.1077ZM26 22H28V26H32V28H28V32H26V28H22V26H26V22Z" class="svg-bg"/>
</svg>
`;
const _s40IconSvg = html `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.7583 12.9296 28.5941.09375 30.0084 1.50796 18.445 13.0713C21.0166 16.9539 20.5921 22.236 17.1715 25.6566 13.7509 29.0772 8.46882 29.5017 4.58619 26.9301L3.02935 28.487 11.5146 36.9722 38.4936 9.99325 39.9079 11.4075 11.5146 39.8007.200928 28.487 4.44455 24.2433C7.56882 27.3666 12.6334 27.3662 15.7573 24.2424 18.8811 21.1185 18.8815 16.0539 15.7583 12.9296ZM33 28H35V33H40V35H35V40H33V35H28V33H33V28Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAddWorkflows is a generated icon component.
 */
let IconMedAddWorkflows = IconMedAddWorkflows_1 = class IconMedAddWorkflows extends IconBaseElement {
    render() {
        return html `${IconMedAddWorkflows_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAddWorkflows.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s40IconSvg],
    ['s48', _s40IconSvg],
    ['s64', _s40IconSvg],
    ['s72', _s40IconSvg],
    ['s80', _s40IconSvg],
]);
IconMedAddWorkflows = IconMedAddWorkflows_1 = __decorate([
    customElement('zui-icon-med-add-workflows')
], IconMedAddWorkflows);
export { IconMedAddWorkflows };
